var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 160C138.938 160 96 202.938 96 256S138.938 352 192 352S288 309.062 288 256S245.062 160 192 160ZM384 64H192C85.999 64 0 150 0 256C0 362 85.999 448 192 448H384C489.999 448 576 362 576 256C576 150 489.999 64 384 64ZM384 384H192C121.42 384 64 326.58 64 256S121.42 128 192 128H384C454.58 128 512 185.42 512 256S454.58 384 384 384Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOff);
export default __webpack_public_path__ + "static/media/toggle-off.755a286dd50045b1fce008f20f4bb632.svg";
export { ForwardRef as ReactComponent };